import {
  CORE_FLIGHTS_CFAR_NAME,
  CoreFlightsCfarExerciseComponents,
} from "@b2bportal/core-types";

import HtsAirCfarNonExercisableContentStyles from "./HtsAirCfarNonExercisableContent.module.scss";

export const CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES = {
  [CORE_FLIGHTS_CFAR_NAME]: {
    [CoreFlightsCfarExerciseComponents.HtsAirCfarNonExercisableContent]:
      HtsAirCfarNonExercisableContentStyles,
  },
};
